import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { legacyHubPrefixRedirect } from '@core/utils/legacy-hub-redirect';
import { AccessDeniedComponent } from '@shared/features/hub-access-denied/access-denied.component';
import { PageNotFoundComponent } from '@shared/features/hub-page-not-found/page-not-found.component';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: '403',
    component: AccessDeniedComponent,
  },
  {
    path: '404',
    component: PageNotFoundComponent,
  },
  {
    path: 'hub',
    redirectTo: legacyHubPrefixRedirect,
  },
  {
    path: '',
    loadChildren: () => import('./features/hub/hub.module').then((m) => m.HubModule),
  },
  {
    path: '**',
    redirectTo: '/404',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingLiteHubModule {}
